export const SECTIONS = [
  { value: "beavers", label: "Beavers", ages: "6-8", tag: "tag-beavers" },
  { value: "cubs", label: "Cubs", ages: "8-11", tag: "tag-cubs" },
  { value: "scouts", label: "Scouts", ages: "11-14", tag: "tag-scouts" },
  { value: "ventures", label: "Ventures", ages: "14-17", tag: "tag-ventures" },
  { value: "leaders", label: "Adult Leaders", ages: "18+", tag: "tag-leaders" },
];

export const sectionLabel = (v) => SECTIONS.find((s) => s.value === v)?.label || v;
export const sectionTag = (v) => SECTIONS.find((s) => s.value === v)?.tag || "tag-scouts";

export const LEDGER_CATEGORIES = [
  { value: "membership_fee", label: "Membership Fee" },
  { value: "fundraising", label: "Fundraising" },
  { value: "donation", label: "Donation" },
  { value: "grant", label: "Grant" },
  { value: "camp", label: "Camp" },
  { value: "uniform", label: "Uniform" },
  { value: "equipment", label: "Equipment" },
  { value: "other", label: "Other" },
];

export const PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "card", label: "Card" },
  { value: "transfer", label: "Bank transfer" },
  { value: "cheque", label: "Cheque" },
  { value: "other", label: "Other" },
];

export const FEE_FREQUENCIES = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "annual", label: "Annual" },
];
